import { useEffect, useState, Fragment, useRef } from "react";
import { useBorrowCart } from "../context/BorrowCartContext";
import { API_BASE_URL } from "../utils/config";
import { useLocation } from "react-router-dom";

const authHeaders = () => {
  const token = localStorage.getItem("accessToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

function normalizeImageUrl(url) {
  if (!url) return null;
  const trimmed = url.trim();
  if (!trimmed) return null;

  const extractDriveId = (value) => {
    if (!value) return null;

    if (/^https?:\/\//i.test(value)) {
      if (value.includes("drive.google.com")) {
        try {
          const match = value.match(/\/file\/d\/([^/]+)/);
          if (match && match[1]) return match[1];

          const urlObj = new URL(value);
          const idParam = urlObj.searchParams.get("id");
          if (idParam) return idParam;
        } catch {
          return null;
        }
      }
      return null;
    }

    if (value.startsWith("uc?") || value.startsWith("/uc?")) {
      const search = value.startsWith("/") ? value.slice(1) : value;
      const parts = search.split("?");
      const query = parts.length > 1 ? parts[1] : parts[0];
      const params = new URLSearchParams(query);
      const id = params.get("id");
      if (id) return id;
    }

    if (value.startsWith("id=")) {
      return value.substring(3).split("&")[0];
    }

    if (/^[A-Za-z0-9_-]{20,}$/.test(value)) {
      return value;
    }

    return null;
  };

  const driveId = extractDriveId(trimmed);
  if (driveId) {
    return `${API_BASE_URL}/api/utils/drive-image/?id=${encodeURIComponent(driveId)}`;
  }

  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return trimmed;
}

function buildExternalImageUrl(raw) {
  if (!raw) return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  if (trimmed.startsWith("uc?") || trimmed.startsWith("/uc?")) {
    const search = trimmed.startsWith("/") ? trimmed.slice(1) : trimmed;
    const parts = search.split("?");
    const query = parts.length > 1 ? parts[1] : parts[0];
    const params = new URLSearchParams(query);
    const id = params.get("id");
    if (id) {
      return `https://drive.google.com/uc?export=view&id=${id}`;
    }
  }

  if (trimmed.startsWith("id=")) {
    const id = trimmed.substring(3).split("&")[0];
    return `https://drive.google.com/uc?export=view&id=${id}`;
  }

  if (/^[A-Za-z0-9_-]{20,}$/.test(trimmed)) {
    return `https://drive.google.com/uc?export=view&id=${trimmed}`;
  }

  return null;
}

function TempItemsList() {
  const { addItem } = useBorrowCart();

  const [user, setUser] = useState(null);

  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState("GIMMICK");
  const [statusFilter, setStatusFilter] = useState("active");
  const [page, setPage] = useState(1);
  const location = useLocation();
  const pageSize = 25;

  const tabOptions = [
    { value: "GIMMICK", label: "Gimmick items" },
    { value: "PRODUCT", label: "Product items" },
    { value: "BOOTH", label: "Booth items" },
  ];
  const tabDisplayNames = {
    GIMMICK: "Gimmick",
    PRODUCT: "Product",
    BOOTH: "Booth",
  };

  const activeTabName = tabDisplayNames[activeTab] || "Temporary";

  const [categories, setCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [locations, setLocations] = useState([]);
  const [loadingLocations, setLoadingLocations] = useState(true);

  const [showForm, setShowForm] = useState(false);
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [locationId, setLocationId] = useState("");
  const [unit, setUnit] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [initialQuantity, setInitialQuantity] = useState("");
  const [eventName, setEventName] = useState("");
  const [eventPicName, setEventPicName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");

  const [posisi, setPosisi] = useState("");
  const [initialDate, setInitialDate] = useState("");
  const [dateLimit, setDateLimit] = useState("");

  const [previewImageUrl, setPreviewImageUrl] = useState(null);
  const [previewRawUrl, setPreviewRawUrl] = useState(null);
  const [previewError, setPreviewError] = useState(false);
  const [loadingImages, setLoadingImages] = useState({});
  const [justAddedId, setJustAddedId] = useState(null);
  const [expandedItemId, setExpandedItemId] = useState(null);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [editCode, setEditCode] = useState("");
  const [editName, setEditName] = useState("");
  const [editCategoryId, setEditCategoryId] = useState("");
  const [editUnit, setEditUnit] = useState("");
  const [editImageUrl, setEditImageUrl] = useState("");
  const [editEventName, setEditEventName] = useState("");
  const [editEventPicName, setEditEventPicName] = useState("");
  const [editPosisi, setEditPosisi] = useState("");
  const [editInitialDate, setEditInitialDate] = useState("");
  const [editDateLimit, setEditDateLimit] = useState("");
  const [editError, setEditError] = useState("");
  const [editLoading, setEditLoading] = useState(false);

  const [showTempOutModal, setShowTempOutModal] = useState(false);
  const [tempOutItem, setTempOutItem] = useState(null);
  const [tempOutQty, setTempOutQty] = useState("");
  const [tempOutError, setTempOutError] = useState("");
  const [tempOutLoading, setTempOutLoading] = useState(false);

  const [openActionsId, setOpenActionsId] = useState(null);
  const [actionsMenuPos, setActionsMenuPos] = useState({ top: 0, left: 0 });

  const externalUrl = buildExternalImageUrl(previewRawUrl);
  const requestIdRef = useRef(0);
  const actionsMenuRef = useRef(null);

  const mapTypeToTab = (type) => {
    const normalized = String(type || "").toLowerCase();

    if (normalized === "production") return "PRODUCT";
    if (normalized === "booth") return "BOOTH";
    return "GIMMICK"; // default
  };

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) return;

    fetch(`${API_BASE_URL}/api/auth/me/`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => setUser(data))
      .catch(() => setUser(null));
  }, []);

  const isAdmin = ["admin", "superadmin"].includes(user?.role);
  const isGuest = user && !["admin", "superadmin"].includes(user.role);

  useEffect(() => {
    if (isGuest && statusFilter !== "active") {
      setStatusFilter("active");
    }
  }, [isGuest, statusFilter]);

  useEffect(() => {
    if (!previewImageUrl) return;

    setPreviewError(false);
    const timeout = setTimeout(() => {
      setPreviewError(true);
    }, 1500);

    return () => clearTimeout(timeout);
  }, [previewImageUrl]);

  useEffect(() => {
    if (!openActionsId) return;

    const handleClickOutside = (event) => {
      if (
        actionsMenuRef.current &&
        !actionsMenuRef.current.contains(event.target)
      ) {
        setOpenActionsId(null);
      }
    };

    const handleWindowChange = () => {
      setOpenActionsId(null);
    };

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleWindowChange, true);
    window.addEventListener("resize", handleWindowChange);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleWindowChange, true);
      window.removeEventListener("resize", handleWindowChange);
    };
  }, [openActionsId]);

  const fetchItems = () => {
    setLoading(true);
    const currentRequestId = ++requestIdRef.current;

    const params = new URLSearchParams();
    params.set("page", page);
    params.set("page_size", pageSize);
    params.set("status", isAdmin ? statusFilter : "active");
    params.set("temporary_only", "true");
    params.set("item_type", activeTab);

    const term = search.trim();
    if (term) params.set("search", term);

    fetch(`${API_BASE_URL}/api/items/?${params.toString()}`, {
      headers: { ...authHeaders() },
    })
      .then(async (res) => {
        if (!res.ok) {
          const data = await res.json().catch(() => null);
          throw new Error(data?.detail || "Failed to load temporary items.");
        }
        return res.json();
      })
      .then((data) => {
        if (currentRequestId !== requestIdRef.current) return;

        const results = Array.isArray(data) ? data : data.results || [];
        setItems(results);

        if (!Array.isArray(data) && typeof data === "object" && typeof data.count === "number") {
          setTotalCount(data.count);
        } else {
          setTotalCount(results.length);
        }
      })
      .catch((err) => {
        if (currentRequestId !== requestIdRef.current) return;
        console.error(err);
      })
      .finally(() => {
        if (currentRequestId !== requestIdRef.current) return;
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, search, activeTab, statusFilter, isAdmin]);

  useEffect(() => {
    setLoadingCategories(true);
    fetch(`${API_BASE_URL}/api/categories/`, {
      headers: { ...authHeaders() },
    })
      .then((res) => res.json())
      .then((data) => {
        setCategories(Array.isArray(data) ? data : data.results || []);
      })
      .catch((err) => {
        console.error("Error fetching categories:", err);
      })
      .finally(() => {
        setLoadingCategories(false);
      });
  }, []);

  useEffect(() => {
    setLoadingLocations(true);
    fetch(`${API_BASE_URL}/api/locations/`, {
      headers: { ...authHeaders() },
    })
      .then((res) => res.json())
      .then((data) => {
        setLocations(Array.isArray(data) ? data : data.results || []);
      })
      .catch((err) => {
        console.error("Error fetching locations:", err);
      })
      .finally(() => {
        setLoadingLocations(false);
      });
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const searchParam = params.get("search");
    const typeParam = params.get("type");

    if (searchParam) {
      setSearch(searchParam);
    }

    if (typeParam) {
      setActiveTab(mapTypeToTab(typeParam));
    }
  }, [location.search]);

  const resetForm = () => {
    setCode("");
    setName("");
    setCategoryId("");
    setLocationId("");
    setUnit("");
    setImageUrl("");
    setInitialQuantity("");
    setEventName("");
    setEventPicName("");
    setPosisi("");
    setInitialDate("");
    setDateLimit("");
    setFormError("");
    setFormSuccess("");
  };

  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

  const getTotalIn = (item) => {
    const total = item.total_in ?? item.quantity_in ?? item.masuk;
    if (total !== undefined && total !== null) return Number(total) || 0;
    return Number(item.stock_awal ?? item.quantity_available ?? 0) || 0;
  };

  const getTotalOut = (item, available) => {
    const explicit = item.total_out ?? item.quantity_out ?? item.keluar;
    if (explicit !== undefined && explicit !== null) return Number(explicit) || 0;

    const totalIn = getTotalIn(item);
    return Math.max(0, totalIn - available);
  };

  const handleToggleLocations = (itemId) => {
    setExpandedItemId((prev) => (prev === itemId ? null : itemId));
  };

  const handleQuickAddToCart = (item) => {
    addItem(
      {
        itemId: item.id,
        code: item.code,
        name: item.name,
        unit: item.unit,
        image_url: item.image_url || item.image || null,
        image: item.image || item.image_url || null,
        available: (item.location_stocks || []).reduce(
          (sum, l) => sum + (Number(l.available) || 0),
          0
        ),
      },
      1
    );

    setJustAddedId(item.id);
    window.setTimeout(() => {
      setJustAddedId((prev) => (prev === item.id ? null : prev));
    }, 1500);
  };

  const handleOpenActionsMenu = (event, itemId) => {
    const rect = event.currentTarget.getBoundingClientRect();

    const menuWidth = 160;
    const gap = 8;
    const left = Math.max(8, rect.right - menuWidth);
    const top = rect.bottom + gap;

    setActionsMenuPos({ top, left });
    setOpenActionsId((prev) => (prev === itemId ? null : itemId));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormError("");
    setFormSuccess("");

    if (!code.trim()) {
      setFormError("Please enter an item code.");
      return;
    }
    if (!name.trim()) {
      setFormError("Please enter an item name.");
      return;
    }
    if (!categoryId) {
      setFormError("Please select a category.");
      return;
    }
    if (!locationId) {
      setFormError("Please select a location.");
      return;
    }
    if (!eventName.trim()) {
      setFormError("Please enter an event name.");
      return;
    }
    if (!eventPicName.trim()) {
      setFormError("Please enter a PIC event name.");
      return;
    }

    let initialQty = 0;
    if (initialQuantity !== "") {
      const num = Number(initialQuantity);
      if (Number.isNaN(num) || num < 0) {
        setFormError("Available stock must be 0 or a positive number.");
        return;
      }
      initialQty = num;
    }

    const payload = {
      code: code.trim(),
      name: name.trim(),
      unit: unit.trim() || null,
      category_id: Number(categoryId),
      location_id: Number(locationId),
      image_url: imageUrl.trim() || null,
      initial_quantity: initialQty > 0 ? initialQty : 0,
      event_name: eventName.trim(),
      event_pic_name: eventPicName.trim(),
      item_type: activeTab,
      is_temporary_item: true,
      posisi: posisi.trim() || "",
      initial_date: initialDate || null,
      date_limit: dateLimit || null,
    };

    setSubmitting(true);

    fetch(`${API_BASE_URL}/api/items/?temporary_only=true`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...authHeaders(),
      },
      body: JSON.stringify(payload),
    })
      .then(async (res) => {
        if (!res.ok) {
          const data = await res.json().catch(() => null);
          let msg = `Failed to create ${activeTabName.toLowerCase()} item.`;
          if (data && typeof data === "object") {
            const firstKey = Object.keys(data)[0];
            if (firstKey && Array.isArray(data[firstKey])) {
              msg = data[firstKey][0];
            } else if (data.detail) {
              msg = data.detail;
            }
          }
          throw new Error(msg);
        }
        return res.json();
      })
      .then(() => {
        setFormSuccess(`${activeTabName} item created successfully.`);
        resetForm();
        setPage(1);
        fetchItems();
      })
      .catch((err) => {
        console.error(err);
        setFormError(err.message || `Failed to create ${activeTabName.toLowerCase()} item.`);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const openEditModal = (item) => {
    setEditItem(item);
    setEditCode(item.code || "");
    setEditName(item.name || "");
    setEditCategoryId(item.category?.id ? String(item.category.id) : "");
    setEditUnit(item.unit || "");
    setEditImageUrl(item.image_url || item.image || "");
    setEditEventName(item.event_name || "");
    setEditEventPicName(item.event_pic_name || "");
    setEditPosisi(item.posisi || "");
    setEditInitialDate(item.initial_date || "");
    setEditDateLimit(item.date_limit || "");
    setEditError("");
    setEditLoading(false);
    setShowEditModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEditItem(null);
    setEditCode("");
    setEditName("");
    setEditCategoryId("");
    setEditUnit("");
    setEditImageUrl("");
    setEditEventName("");
    setEditEventPicName("");
    setEditPosisi("");
    setEditInitialDate("");
    setEditDateLimit("");
    setEditError("");
    setEditLoading(false);
  };

  const handleUpdateItem = async (e) => {
    e.preventDefault();
    if (!editItem) return;

    setEditError("");

    if (!editCode.trim()) {
      setEditError("Item code is required.");
      return;
    }
    if (!editName.trim()) {
      setEditError("Item name is required.");
      return;
    }
    if (!editCategoryId) {
      setEditError("Category is required.");
      return;
    }
    if (!editEventName.trim()) {
      setEditError("Event name is required.");
      return;
    }
    if (!editEventPicName.trim()) {
      setEditError("PIC event name is required.");
      return;
    }

    const payload = {
      ...(editItem || {}),
      code: editCode.trim(),
      name: editName.trim(),
      unit: editUnit.trim() || null,
      category_id: Number(editCategoryId),
      image_url: editImageUrl.trim() || null,
      event_name: editEventName.trim(),
      event_pic_name: editEventPicName.trim(),
      item_type: editItem.item_type,
      posisi: editPosisi.trim() || "",
      initial_date: editInitialDate || null,
      date_limit: editDateLimit || null,
    };

    setEditLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/items/${editItem.id}/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          ...authHeaders(),
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json().catch(() => null);
      if (!res.ok) {
        let msg = "Failed to update temporary item.";
        if (data && typeof data === "object") {
          const firstKey = Object.keys(data)[0];
          if (firstKey && Array.isArray(data[firstKey])) {
            msg = `${firstKey}: ${data[firstKey][0]}`;
          } else if (data.detail) {
            msg = data.detail;
          }
        }
        throw new Error(msg);
      }

      setItems((prev) => prev.map((it) => (it.id === data.id ? data : it)));
      closeEditModal();
    } catch (err) {
      console.error(err);
      setEditError(err.message || "Failed to update temporary item.");
      setEditLoading(false);
    }
  };

  const handleHideItem = () => {
    if (!editItem) return;
    if (!window.confirm("Hide this item? It will be removed from the active list.")) return;

    setEditError("");
    setEditLoading(true);

    fetch(`${API_BASE_URL}/api/items/${editItem.id}/`, {
      method: "DELETE",
      headers: { ...authHeaders() },
    })
      .then((res) => {
        if (!res.ok && res.status !== 204) throw new Error("Failed to hide item.");
        setItems((prev) => prev.filter((it) => it.id !== editItem.id));
        closeEditModal();
      })
      .catch((err) => {
        console.error(err);
        setEditError("Failed to hide item.");
        setEditLoading(false);
      });
  };

  const handleRestoreItem = () => {
    if (!editItem) return;

    setEditError("");
    setEditLoading(true);

    const payload = { ...editItem, is_active: true };

    fetch(`${API_BASE_URL}/api/items/${editItem.id}/`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...authHeaders(),
      },
      body: JSON.stringify(payload),
    })
      .then(async (res) => {
        const data = await res.json().catch(() => null);
        if (!res.ok) throw new Error(data?.detail || "Failed to restore item.");
        return data;
      })
      .then((updated) => {
        setItems((prev) => prev.map((it) => (it.id === updated.id ? updated : it)));
        closeEditModal();
      })
      .catch((err) => {
        console.error(err);
        setEditError(err.message || "Failed to restore item.");
        setEditLoading(false);
      });
  };

  const openTempOutModal = (item) => {
    setTempOutItem(item);
    setTempOutQty("");
    setTempOutError("");
    setTempOutLoading(false);
    setShowTempOutModal(true);
  };

  const tempOutAvailable = tempOutItem
    ? (tempOutItem.location_stocks || []).reduce(
        (sum, l) => sum + (Number(l.available) || 0),
        0
      )
    : 0;

  const closeTempOutModal = () => {
    setShowTempOutModal(false);
    setTempOutItem(null);
    setTempOutQty("");
    setTempOutError("");
    setTempOutLoading(false);
  };

  const handleTempOut = async (e) => {
    e.preventDefault();
    if (!tempOutItem) return;

    const available = tempOutAvailable;

    setTempOutLoading(true);
    setTempOutError("");

    if (available === 0) {
      try {
        const res = await fetch(`${API_BASE_URL}/api/items/${tempOutItem.id}/`, {
          method: "DELETE",
          headers: { ...authHeaders() },
        });

        if (!res.ok && res.status !== 204) {
          throw new Error("Failed to remove item.");
        }

        closeTempOutModal();
        fetchItems();
      } catch (err) {
        setTempOutError(err.message);
        setTempOutLoading(false);
      }
      return;
    }

    const qty = Number(tempOutQty);

    if (!qty || qty <= 0) {
      setTempOutError("Enter a valid quantity.");
      setTempOutLoading(false);
      return;
    }

    if (qty > available) {
      setTempOutError("Quantity exceeds available stock.");
      setTempOutLoading(false);
      return;
    }

    try {
      const res = await fetch(
        `${API_BASE_URL}/api/items/${tempOutItem.id}/temp-out/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...authHeaders(),
          },
          body: JSON.stringify({ quantity: qty }),
        }
      );

      const data = await res.json().catch(() => null);

      if (!res.ok) {
        throw new Error(data?.detail || "Failed temp out.");
      }

      closeTempOutModal();
      fetchItems(); // refresh
    } catch (err) {
      setTempOutError(err.message);
      setTempOutLoading(false);
    }
  };

  const markImageLoading = (itemId) => {
    setLoadingImages((prev) => ({ ...prev, [itemId]: true }));
  };

  const markImageDone = (itemId) => {
    setLoadingImages((prev) => ({ ...prev, [itemId]: false }));
  };

  return (
    <div>
      <div className="mb-4">
        <h1 className="text-2xl font-semibold">Temporary Items</h1>
        <p className="text-sm text-muted mt-1">{activeTabName}</p>
      </div>

      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4">
        <div className="flex flex-col md:flex-row md:items-center gap-3">
          <input
            type="text"
            value={search}
            onChange={(e) => {
              setPage(1);
              setSearch(e.target.value);
            }}
            placeholder="Search by code, name, category, location…"
            className="w-full md:w-[480px] rounded-md border border-white/50 dark:border-white/15 px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
          />

          <select
            value={activeTab}
            onChange={(e) => {
              setPage(1);
              setActiveTab(e.target.value);
            }}
            className="text-xs rounded-md border border-white/50 dark:border-white/15 px-2 py-1 bg-white/80 dark:bg-white/5 md:w-auto"
          >
            {tabOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>

          {isAdmin && (
            <select
              value={statusFilter}
              onChange={(e) => {
                setPage(1);
                setStatusFilter(e.target.value);
              }}
              className="text-xs rounded-md border border-white/50 dark:border-white/15 px-2 py-1 bg-white/80 dark:bg-white/5 md:w-auto"
            >
              <option value="active">Active items</option>
              <option value="hidden">Hidden items</option>
              <option value="all">All items</option>
            </select>
          )}
        </div>

        {isAdmin && (
          <button
            type="button"
            onClick={() => setShowForm((prev) => !prev)}
            className="inline-flex items-center justify-center rounded-md bg-brand-600 text-white text-sm font-semibold px-4 py-2 hover:bg-brand-700"
          >
            {showForm ? "Hide form" : `Add ${activeTabName} item`}
          </button>
        )}
      </div>

      {showForm && (
        <div className="glass-card p-4 mb-4">
          <h2 className="text-sm font-semibold mb-3">
            Add New {activeTabName} Item
          </h2>

          {formError && (
            <div className="mb-2 text-xs text-red-600">{formError}</div>
          )}
          {formSuccess && (
            <div className="mb-2 text-xs text-green-600">{formSuccess}</div>
          )}

          <form
            onSubmit={handleSubmit}
            className="grid gap-3 md:grid-cols-2 lg:grid-cols-3"
          >
            <div>
              <label className="block text-xs font-medium text-muted mb-1">
                Item Code *
              </label>
              <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
                placeholder="e.g. G-001"
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-muted mb-1">
                Item Name *
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-muted mb-1">
                Category *
              </label>
              <select
                value={categoryId}
                onChange={(e) => setCategoryId(e.target.value)}
                className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm bg-white/80 dark:bg-white/5 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
              >
                <option value="">
                  {loadingCategories ? "Loading categories…" : "Select category"}
                </option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-xs font-medium text-muted mb-1">
                Location *
              </label>
              <select
                value={locationId}
                onChange={(e) => setLocationId(e.target.value)}
                className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm bg-white/80 dark:bg-white/5 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
              >
                <option value="">
                  {loadingLocations ? "Loading locations…" : "Select location"}
                </option>
                {locations.map((loc) => (
                  <option key={loc.id} value={loc.id}>
                    {loc.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-xs font-medium text-muted mb-1">
                Unit
              </label>
              <input
                type="text"
                value={unit}
                onChange={(e) => setUnit(e.target.value)}
                className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
                placeholder="e.g. pcs, set, unit"
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-muted mb-1">
                Available stock
              </label>
              <input
                type="number"
                min="0"
                value={initialQuantity}
                onChange={(e) => setInitialQuantity(e.target.value)}
                className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
                placeholder="e.g. 10"
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-muted mb-1">
                Event Name *
              </label>
              <input
                type="text"
                value={eventName}
                onChange={(e) => setEventName(e.target.value)}
                className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-muted mb-1">
                PIC Event Name *
              </label>
              <input
                type="text"
                value={eventPicName}
                onChange={(e) => setEventPicName(e.target.value)}
                className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-muted mb-1">
                Posisi
              </label>
              <input
                type="text"
                value={posisi}
                onChange={(e) => setPosisi(e.target.value)}
                className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
                placeholder="e.g. Rak A1 / Zona 2"
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-muted mb-1">
                Initial Date
              </label>
              <input
                type="date"
                value={initialDate}
                onChange={(e) => setInitialDate(e.target.value)}
                className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-muted mb-1">
                Date Limit
              </label>
              <input
                type="date"
                value={dateLimit}
                onChange={(e) => setDateLimit(e.target.value)}
                className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
              />
            </div>

            <div className="md:col-span-2 lg:col-span-3">
              <label className="block text-xs font-medium text-muted mb-1">
                Image URL
              </label>
              <input
                type="text"
                value={imageUrl}
                onChange={(e) => setImageUrl(e.target.value)}
                className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
                placeholder="https://example.com/image.jpg"
              />
            </div>

            <div className="md:col-span-2 lg:col-span-3 flex justify-end mt-1">
              <button
                type="submit"
                disabled={submitting}
                className="inline-flex items-center justify-center rounded-md bg-brand-600 text-white text-sm font-semibold px-4 py-2 hover:bg-brand-700 disabled:opacity-60"
              >
                {submitting ? "Saving…" : `Save ${activeTabName} Item`}
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="glass-card relative overflow-visible">
        <div className="overflow-x-auto overflow-y-visible">
          <table className="min-w-[1650px] w-full text-sm table-auto">
            <thead>
              <tr>
                <th className="px-4 py-2 text-left text-xs font-semibold text-muted uppercase whitespace-nowrap">
                  Code
                </th>
                <th className="px-4 py-2 text-left text-xs font-semibold text-muted uppercase">
                  Name
                </th>
                <th className="px-4 py-2 text-left text-xs font-semibold text-muted uppercase">
                  Category
                </th>
                <th className="px-4 py-2 text-left text-xs font-semibold text-muted uppercase whitespace-nowrap">
                  Location
                </th>
                <th className="px-4 py-2 text-left text-xs font-semibold text-muted uppercase whitespace-nowrap">
                  Unit
                </th>
                <th className="px-4 py-2 text-right text-xs font-semibold text-muted uppercase whitespace-nowrap">
                  Stock
                </th>
                <th className="px-4 py-2 text-right text-xs font-semibold text-muted uppercase whitespace-nowrap">
                  Keluar
                </th>
                <th className="px-4 py-2 text-right text-xs font-semibold text-muted uppercase whitespace-nowrap">
                  Available
                </th>
                <th className="px-4 py-2 text-left text-xs font-semibold text-muted uppercase">
                  Event
                </th>
                <th className="px-4 py-2 text-left text-xs font-semibold text-muted uppercase whitespace-nowrap">
                  PIC
                </th>
                <th className="px-4 py-2 text-left text-xs font-semibold text-muted uppercase whitespace-nowrap">
                  Posisi
                </th>
                <th className="px-4 py-2 text-left text-xs font-semibold text-muted uppercase whitespace-nowrap">
                  Initial Date
                </th>
                <th className="px-4 py-2 text-left text-xs font-semibold text-muted uppercase whitespace-nowrap">
                  Date Limit
                </th>
                <th className="px-4 py-2 text-center text-xs font-semibold text-muted uppercase whitespace-nowrap">
                  Image
                </th>
                <th className="px-4 py-2 text-center text-xs font-semibold text-muted uppercase whitespace-nowrap">
                  Actions
                </th>
              </tr>
            </thead>

            <tbody>
              {loading && (
                <tr>
                  <td colSpan={15} className="px-4 py-4 text-center text-muted">
                    Loading temporary items...
                  </td>
                </tr>
              )}

              {!loading &&
                items.map((item) => {
                  const available = (item.location_stocks || []).reduce(
                    (sum, ls) => sum + (Number(ls.available) || 0),
                    0
                  );

                  const stock = getTotalIn(item);
                  const keluar = getTotalOut(item, available);

                  const rawImg = item.image || item.image_url || item.gambar || null;
                  const img = normalizeImageUrl(rawImg);

                  if (img && loadingImages[item.id] === undefined) {
                    markImageLoading(item.id);
                  }

                  return (
                    <Fragment key={item.id}>
                      <tr className="border-t">
                        <td className="px-4 py-2 font-semibold whitespace-nowrap align-top">
                          {item.code}
                        </td>

                        <td className="px-4 py-2 align-top">
                          <div className="min-w-[170px] max-w-[420px] break-words">
                            {item.name}
                          </div>
                        </td>

                        <td className="px-4 py-2 align-top">
                          <div className="min-w-[150px] max-w-[200px] break-words">
                            {item.category?.name || "-"}
                          </div>
                        </td>

                        <td className="px-4 py-2 align-top whitespace-nowrap">
                          {item.location_stocks && item.location_stocks.length > 0 ? (
                            <button
                              type="button"
                              onClick={() => handleToggleLocations(item.id)}
                              className="inline-flex items-center gap-1 text-xs font-medium text-brand-600 hover:text-brand-800"
                            >
                              <span>
                                {expandedItemId === item.id ? "Hide locations" : "View locations"}
                              </span>
                              <span className="text-[10px] text-muted">
                                ({item.location_stocks.length})
                              </span>
                            </button>
                          ) : (
                            <span className="text-xs text-muted">-</span>
                          )}
                        </td>

                        <td className="px-4 py-2 text-xs text-muted whitespace-nowrap align-top">
                          {item.unit || "-"}
                        </td>

                        <td className="px-4 py-2 text-right whitespace-nowrap align-top">
                          {stock}
                        </td>

                        <td className="px-4 py-2 text-right whitespace-nowrap align-top">
                          {keluar}
                        </td>

                        <td className="px-4 py-2 text-right font-semibold whitespace-nowrap align-top">
                          {available}
                        </td>

                        <td className="px-4 py-2 text-xs text-muted align-top">
                          <div className="min-w-[140px] max-w-[400px] break-words">
                            {item.event_name || "-"}
                          </div>
                        </td>

                        <td className="px-4 py-2 text-xs text-muted align-top">
                          <div className="min-w-[140px] max-w-[300px] break-words">
                            {item.event_pic_name || "-"}
                          </div>
                        </td>

                        <td className="px-4 py-2 text-xs text-muted whitespace-nowrap align-top">
                          {item.posisi || "-"}
                        </td>

                        <td className="px-4 py-2 text-xs text-muted whitespace-nowrap align-top">
                          {item.initial_date || "-"}
                        </td>

                        <td className="px-4 py-2 text-xs text-muted whitespace-nowrap align-top">
                          {item.date_limit || "-"}
                        </td>

                        <td className="px-4 py-2 text-center align-top">
                          {img ? (
                            <button
                              type="button"
                              onClick={() => {
                                setPreviewImageUrl(img);
                                setPreviewRawUrl(rawImg);
                                setPreviewError(false);
                              }}
                              className="inline-block"
                            >
                              <div className="relative inline-block h-10 w-10">
                                {loadingImages[item.id] !== false && (
                                  <div className="absolute inset-0 flex items-center justify-center bg-white/70 rounded border border-white/40 dark:border-white/10">
                                    <div className="h-4 w-4 animate-spin rounded-full border-2 border-white/50 dark:border-white/15 border-t-brand-600" />
                                  </div>
                                )}

                                <img
                                  src={img}
                                  alt={item.name}
                                  onLoad={() => markImageDone(item.id)}
                                  onError={() => markImageDone(item.id)}
                                  onLoadStart={() => markImageLoading(item.id)}
                                  className="h-10 w-10 rounded object-cover border border-white/40 dark:border-white/10 hover:opacity-80 transition"
                                />
                              </div>
                            </button>
                          ) : (
                            <div className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-black/5 dark:bg-white/10 text-[10px] text-muted border border-white/40 dark:border-white/10">
                              N/A
                            </div>
                          )}
                        </td>

                        <td className="px-4 py-2 text-center align-top whitespace-nowrap">
                          {!isAdmin ? (
                            <button
                              type="button"
                              onClick={() => handleQuickAddToCart(item)}
                              className="inline-flex items-center justify-center rounded-md border border-brand-300 text-brand-700 text-xs font-semibold px-3 py-1.5 hover:bg-brand-50"
                            >
                              {justAddedId === item.id ? "Added ✓" : "Add to cart"}
                            </button>
                          ) : (
                            <div className="flex items-center justify-center">
                              <button
                                type="button"
                                onClick={(e) => handleOpenActionsMenu(e, item.id)}
                                className="inline-flex items-center gap-2 px-3 py-1.5 text-xs font-semibold rounded-md border border-white/50 dark:border-white/15 text-strong hover:bg-brand-500/5"
                              >
                                Actions
                                <span className="text-[10px]">
                                  {openActionsId === item.id ? "▴" : "▾"}
                                </span>
                              </button>
                            </div>
                          )}
                        </td>
                      </tr>

                      {expandedItemId === item.id && (
                        <tr className="border-t bg-brand-500/5">
                          <td colSpan={15} className="px-8 py-3">
                            <div className="text-xs text-strong">
                              <table className="min-w-[320px] text-xs">
                                <thead>
                                  <tr className="text-left text-muted">
                                    <th className="py-1 pr-4">Location</th>
                                    <th className="py-1 pr-4 text-right">Available</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {item.location_stocks.map((ls) => (
                                    <tr key={ls.location?.id || ls.location_name}>
                                      <td className="py-0.5 pr-4">
                                        {ls.location?.name || ls.location_name || "-"}
                                      </td>
                                      <td className="py-0.5 pr-4 text-right">
                                        {ls.available ?? 0}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                    </Fragment>
                  );
                })}

              {!loading && items.length === 0 && (
                <tr>
                  <td colSpan={15} className="px-4 py-4 text-center text-muted">
                    No temporary items found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {isAdmin && openActionsId && (
        <div
          ref={actionsMenuRef}
          className="fixed w-40 bg-white/80 dark:bg-white/5 border border-white/40 dark:border-white/10 rounded-md shadow-lg z-[9999] overflow-hidden text-left"
          style={{
            top: `${actionsMenuPos.top}px`,
            left: `${actionsMenuPos.left}px`,
          }}
        >
          {(() => {
            const item = items.find((it) => it.id === openActionsId);
            if (!item) return null;

            const isHidden = item.is_active === false;

            return (
              <>
                {!isHidden && (
                  <button
                    type="button"
                    onClick={() => {
                      setOpenActionsId(null);
                      handleQuickAddToCart(item);
                    }}
                    className="w-full text-left px-3 py-2 text-xs hover:bg-brand-500/5"
                  >
                    {justAddedId === item.id ? "Added ✓" : "Add to cart"}
                  </button>
                )}

                <button
                  type="button"
                  onClick={() => {
                    setOpenActionsId(null);
                    openEditModal(item);
                  }}
                  className="w-full text-left px-3 py-2 text-xs hover:bg-brand-500/5"
                >
                  Edit
                </button>

                {!isHidden && (
                  <button
                    type="button"
                    onClick={() => {
                      setOpenActionsId(null);
                      openTempOutModal(item);
                    }}
                    className="w-full text-left px-3 py-2 text-xs hover:bg-red-50 text-red-600"
                  >
                    Temp Out
                  </button>
                )}
              </>
            );
          })()}
        </div>
      )}

      <div className="flex justify-between items-center mt-4">
        <button
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={page === 1}
          onClick={() => setPage(1)}
        >
          « First
        </button>

        <button
          className="px-3 py-1 border rounded disabled:opacity-50 ml-2"
          disabled={page <= 1}
          onClick={() => setPage(page - 1)}
        >
          ‹ Prev
        </button>

        <span className="text-sm mx-4">
          Page {page} of {totalPages}
        </span>

        <button
          className="px-3 py-1 border rounded disabled:opacity-50 mr-2"
          disabled={page >= totalPages}
          onClick={() => setPage(page + 1)}
        >
          Next ›
        </button>

        <button
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={page === totalPages}
          onClick={() => setPage(totalPages)}
        >
          Last »
        </button>
      </div>

      {previewImageUrl && (
        <div
          className="fixed inset-0 z-40 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm"
          onClick={() => {
            setPreviewImageUrl(null);
            setPreviewRawUrl(null);
            setPreviewError(false);
          }}
        >
          <div
            className="glass-card max-w-3xl w-full p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-2">
              <h2 className="text-sm font-semibold">Item image</h2>
              <button
                type="button"
                className="text-xs text-muted hover:text-strong"
                onClick={() => {
                  setPreviewImageUrl(null);
                  setPreviewRawUrl(null);
                  setPreviewError(false);
                }}
              >
                Close
              </button>
            </div>

            <div className="flex flex-col items-center gap-3">
              <img
                src={previewImageUrl}
                alt="Item"
                className="max-h-[70vh] object-contain rounded-md"
                onLoad={() => setPreviewError(false)}
                onError={() => setPreviewError(true)}
              />

              {previewError && externalUrl && (
                <div className="text-xs text-muted text-center mt-2">
                  If preview doesn&apos;t load,{" "}
                  <a
                    href={externalUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="text-brand-600 hover:underline"
                  >
                    Open image in new tab
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {showEditModal && editItem && (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm">
          <div className="glass-card w-full max-w-lg p-5">
            <h2 className="text-sm font-semibold mb-3">
              Edit temporary item{" "}
              <span className="font-mono">
                {editItem.code} – {editItem.name}
              </span>
            </h2>

            <form onSubmit={handleUpdateItem} className="grid gap-3 md:grid-cols-2">
              <div className="md:col-span-2">
                <label className="block text-xs font-medium text-muted mb-1">
                  Item Code *
                </label>
                <input
                  type="text"
                  value={editCode}
                  onChange={(e) => setEditCode(e.target.value)}
                  className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-xs font-medium text-muted mb-1">
                  Item Name *
                </label>
                <input
                  type="text"
                  value={editName}
                  onChange={(e) => setEditName(e.target.value)}
                  className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm"
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-muted mb-1">
                  Category *
                </label>
                <select
                  value={editCategoryId}
                  onChange={(e) => setEditCategoryId(e.target.value)}
                  className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm bg-white/80 dark:bg-white/5"
                >
                  <option value="">
                    {loadingCategories ? "Loading categories..." : "Select category"}
                  </option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-xs font-medium text-muted mb-1">
                  Unit
                </label>
                <input
                  type="text"
                  value={editUnit}
                  onChange={(e) => setEditUnit(e.target.value)}
                  className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-xs font-medium text-muted mb-1">
                  Event Name *
                </label>
                <input
                  type="text"
                  value={editEventName}
                  onChange={(e) => setEditEventName(e.target.value)}
                  className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-xs font-medium text-muted mb-1">
                  PIC Event Name *
                </label>
                <input
                  type="text"
                  value={editEventPicName}
                  onChange={(e) => setEditEventPicName(e.target.value)}
                  className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-xs font-medium text-muted mb-1">
                  Posisi
                </label>
                <input
                  type="text"
                  value={editPosisi}
                  onChange={(e) => setEditPosisi(e.target.value)}
                  className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm"
                  placeholder="e.g. Rak A1 / Zona 2"
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-muted mb-1">
                  Initial Date
                </label>
                <input
                  type="date"
                  value={editInitialDate}
                  onChange={(e) => setEditInitialDate(e.target.value)}
                  className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm"
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-muted mb-1">
                  Date Limit
                </label>
                <input
                  type="date"
                  value={editDateLimit}
                  onChange={(e) => setEditDateLimit(e.target.value)}
                  className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-xs font-medium text-muted mb-1">
                  Image URL
                </label>
                <input
                  type="text"
                  value={editImageUrl}
                  onChange={(e) => setEditImageUrl(e.target.value)}
                  className="w-full rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm"
                  placeholder="https://..."
                />
              </div>

              <div className="md:col-span-2 mt-1">
                {editError && (
                  <div className="text-xs text-red-600 mb-2">{editError}</div>
                )}
                <div className="flex justify-between items-center gap-2">
                  <div>
                    {editItem?.is_active !== false ? (
                      <button
                        type="button"
                        onClick={handleHideItem}
                        disabled={editLoading}
                        className="px-3 py-1.5 text-xs rounded-md border border-red-500 text-red-600 bg-white/80 dark:bg-white/5 hover:bg-red-50 disabled:opacity-60"
                      >
                        Hide item
                      </button>
                    ) : (
                      <button
                        type="button"
                        onClick={handleRestoreItem}
                        disabled={editLoading}
                        className="px-3 py-1.5 text-xs rounded-md border border-green-500 text-green-600 bg-white/80 dark:bg-white/5 hover:bg-green-50 disabled:opacity-60"
                      >
                        Restore item
                      </button>
                    )}
                  </div>

                  <div className="flex gap-2">
                    <button
                      type="button"
                      className="px-3 py-1.5 text-xs rounded-md border border-white/50 dark:border-white/15 text-strong bg-white/80 dark:bg-white/5 hover:bg-brand-500/5"
                      onClick={closeEditModal}
                      disabled={editLoading}
                    >
                      Cancel
                    </button>

                    <button
                      type="submit"
                      disabled={editLoading}
                      className="px-3 py-1.5 text-xs rounded-md bg-brand-600 text-white font-semibold hover:bg-brand-700"
                    >
                      {editLoading ? "Saving…" : "Save"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {showTempOutModal && tempOutItem && (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm">
          <div className="glass-card w-full max-w-sm p-5">
            <h2 className="text-sm font-semibold mb-3">
              Temp Out – {tempOutItem.code}
            </h2>

            <form onSubmit={handleTempOut} className="space-y-3">
              {tempOutAvailable === 0 ? (
                <div className="text-xs text-muted">
                  Stock is already 0. Confirming will remove this item from the active list.
                </div>
              ) : (
                <div>
                  <label className="text-xs text-muted">
                    Quantity to remove
                  </label>
                  <input
                    type="number"
                    min="1"
                    value={tempOutQty}
                    onChange={(e) => setTempOutQty(e.target.value)}
                    className="w-full border rounded px-3 py-2 text-sm"
                  />
                </div>
              )}

              {tempOutError && (
                <div className="text-xs text-red-600">
                  {tempOutError}
                </div>
              )}

              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  onClick={closeTempOutModal}
                  className="px-3 py-1.5 text-xs border rounded"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  disabled={tempOutLoading}
                  className="px-3 py-1.5 text-xs bg-red-600 text-white rounded"
                >
                  {tempOutLoading
                    ? "Processing..."
                    : tempOutAvailable === 0
                    ? "Remove item"
                    : "Confirm"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default TempItemsList;